"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackUserFlowStep } from "@/lib/analytics";

// Define the main user flows and their steps
const USER_FLOWS = {
  onboarding: {
    steps: [
      { path: "/register", name: "registration", stepNumber: 1 },
      { path: "/onboarding", name: "user_details", stepNumber: 2 },
      { path: "/quickstart", name: "quickstart_arrival", stepNumber: 3 },
    ],
  },
  quickstart: {
    steps: [{ path: "/quickstart", name: "quickstart_view", stepNumber: 1 }],
  },
  returning_user: {
    steps: [{ path: "/quickstart", name: "return_quickstart", stepNumber: 1 }],
  },
};

export function UserFlowTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Track user flow steps based on current path
    Object.entries(USER_FLOWS).forEach(([flowName, flow]) => {
      const currentStep = flow.steps.find((step) => step.path === pathname);
      if (currentStep) {
        trackUserFlowStep(flowName, currentStep.name, currentStep.stepNumber);
      }
    });

    // Track general page navigation
    const pageNames: { [key: string]: string } = {
      "/": "home",
      "/login": "login",
      "/quickstart": "quickstart",
      "/account": "account",
      "/api-keys": "api_keys",
      "/billing": "billing",
      "/logs": "logs",
      "/overview": "overview",
      "/terms": "terms",
      "/terms/terms-of-use": "terms_of_use",
      "/terms/privacy-policy": "privacy_policy",
      "/terms/applicant-privacy-notice": "applicant_privacy_notice",
      "/research": "research",
      "/careers": "careers",
      "/agentica": "agentica",
      "/agentica-sdk": "agentica_sdk",
      "/blog": "blog",
      "/reset-password": "reset_password",
    };

    const pageName =
      pageNames[pathname] || pathname.replace("/", "").replace(/\//g, "_");
    if (pageName) {
      trackUserFlowStep("general_navigation", `page_${pageName}`, 1);
    }
  }, [pathname]);

  return null; // This component doesn't render anything
}
